<template>
  <div>
    <template v-if="$root.isMobile && small">
      <v-skeleton-loader type="list-item" class="ma-2" v-if="loading"/>
      <v-simple-table v-else class="pt-5">
        <template v-slot:default>
          <template v-for="key in Object.keys(totalsCountsNames)">
            <tr v-if="totalsCounts.hasOwnProperty(key)" :key="key">
              <td class="pl-2" style="border-bottom: 1px solid #ccc;">{{totalsCountsNames[key]}}</td>
              <td style="border-bottom: 1px solid #ccc;">
                <h4>
                  <template v-if="totalsCountsTypes[key] === 'Miles'">
                    {{totalsCounts[key].toLocaleString()}}{{$t('milesShort')}}
                  </template>
                  <template v-else-if="totalsCountsTypes[key] === 'Money'">
                    {{$root.moneyValue(totalsCounts[key], 0)}}
                  </template>
                  <template v-else>
                    {{totalsCounts[key]}}
                  </template>
                </h4>
              </td>
            </tr>
          </template>
        </template>
      </v-simple-table>
    </template>
    <template v-else-if="$root.isMobile">
      <v-skeleton-loader type="list-item" class="ma-2" v-if="loading"/>
      <v-list class="list-more-dense" v-else>
        <template v-for="key in Object.keys(totalsCountsNames)">
          <v-list-item v-if="totalsCounts.hasOwnProperty(key)" :key="key">
            <v-list-item-title>{{totalsCountsNames[key]}}</v-list-item-title>
            <v-list-item-action>
              <h4>
                <template v-if="totalsCountsTypes[key] === 'Miles'">
                  {{totalsCounts[key].toLocaleString()}}{{$t('milesShort')}}
                </template>
                <template v-else-if="totalsCountsTypes[key] === 'Money'">
                  {{$root.moneyValue(totalsCounts[key], 0)}}
                </template>
                <template v-else>
                  {{totalsCounts[key]}}
                </template>
              </h4>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list>
    </template>
    <template v-else>
      <v-skeleton-loader type="table-row" v-if="loading"/>
      <v-simple-table dense class="mb-5" v-else>
        <template v-slot:default>
          <thead>
            <tr>
              <template v-for="key in Object.keys(totalsCountsNames)">
                <th v-if="totalsCounts.hasOwnProperty(key)" :key="'header' + key" class="text-center">{{totalsCountsNames[key]}}</th>
              </template>
            </tr>
          </thead>
          <tbody>
            <tr>
              <template v-for="key in Object.keys(totalsCountsNames)">
                <td v-if="totalsCounts.hasOwnProperty(key)" :key="'row' + key" class="text-center">
                  <h2>
                    <template v-if="totalsCountsTypes[key] === 'Miles'">
                      {{totalsCounts[key].toLocaleString()}}{{$t('milesShort')}}
                    </template>
                    <template v-else-if="totalsCountsTypes[key] === 'Money'">
                      {{$root.moneyValue(totalsCounts[key], 2)}}
                    </template>
                    <template v-else>
                      {{totalsCounts[key]}}
                    </template>
                  </h2>
                </td>
              </template>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
  </div>
</template>

<script>
import reportsMixin from '../../mixins/reportsMixin.js';
export default {
  name: 'InvoicesTotals',
  props: ['to', 'from', 'totalsCounts', 'small'],
  mixins: [ reportsMixin ],
  components: {
  },
  data: function () {
    return {
      loading: false
    };
  },
  mounted () {
    this.setInvoicesTotalsHeaders();
  },
  computed: {
    totalsCountsNames () {
      return this.$store.getters['reports/totalsCountsNames'];
    },
    totalsCountsTypes () {
      return this.$store.getters['reports/totalsCountsTypes'];
    }
  },
  methods: {
  }
};
</script>
